<template>
	<div :style="{direction: $vs.rtl ? 'rtl' : 'ltr'}">
		<feather-icon
			icon="EditIcon"
			svgClasses="h-5 w-5 mr-2 hover:text-primary cursor-pointer"
			:title="$t('Edit')"
			@click="editRecord"
		/>
		<feather-icon
			icon="FileTextIcon"
			svgClasses="h-5 w-5 mr-2 hover:text-warning cursor-pointer"
			:title="$t('SeeDetailedInformation')"
			@click="seeDetailInformation"
		/>
		<feather-icon
			v-if="breakDeletePermission"
			icon="Trash2Icon"
			svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
			:title="$t('Crud.Delete')"
			@click="confirmDeleteRecord"
		/>
	</div>
</template>

<script>
import moduleBreaks from "@/store/breaks/moduleBreaks.js";

export default {
	name: "CellRendererActions",
	computed: {
		breakDeletePermission() {
			return this.$store.getters.checkPermission("BREAKS_D");
		},
		breaksData() {
			return this.$store.state.moduleBreaks.breaks;
		},
	},
	methods: {
		editRecord() {
			this.$router.push("/dashboard/update-break/" + this.params.data.id).catch(() => {});
		},
		seeDetailInformation() {
			this.$router.push("/dashboard/breaks/break-view/" + this.params.data.id).catch(() => {});
		},
		confirmDeleteRecord() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("RemoveBreak.Text1") + ` "${this.params.data.name}"? ` + this.$t("RemoveBreak.Text2"),
				accept: this.deleteRecord,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteRecord() {
			this.$store
				.dispatch("moduleBreaks/removeItem", this.params.data.id)
				.then((res) => {
					if (this.breaksData.length > 0) {
						this.params.onBreakList(this.params.currentPageLocal);
					} else {
						this.params.onBreakList(this.params.currentPageLocal - 1);
					}
					this.showDeleteSuccess();
					return res;
				})
				.catch((err) => {
					console.error(err);
				});
		},
		showDeleteSuccess() {
			this.$vs.notify({
				color: "success",
				title: this.$t("TitleConfirmBreakDelete"),
				text: this.$t("TextConfirmBreakDelete"),
			});
		},
	},
	created() {
		if (!moduleBreaks.isRegistered) {
			this.$store.registerModule("moduleBreaks", moduleBreaks);
			moduleBreaks.isRegistered = true;
		}
	},
};
</script>
